import { keysToCamelCase } from '@hotjar/insights-common/lib/convert-string';
import type {
  DeleteProfileResponse,
  DeleteProfileResponseDto,
  SaveProfileResponse,
  SaveProfileResponseDto,
} from './types';

export const saveProfileResponseDtoToModel = (
  response: SaveProfileResponseDto,
): SaveProfileResponse => keysToCamelCase(response);

export const deleteProfileResponseDtoToModel = (
  response: DeleteProfileResponseDto,
): DeleteProfileResponse => keysToCamelCase(response);
